module.exports = __webpack_public_path__ + "img/auto.d830128.svg";